// extracted by mini-css-extract-plugin
module.exports = {"notificationRules":"NotificationRules_notificationRules__17ipj","title":"NotificationRules_title__2CDho","hint":"NotificationRules_hint__3dBCi"};